const pettyCash = [
  {
    vid: 1129,
    submit_on: new Date(),
    amount: 10000,
    l1_status: "Approved",
    l2_status: "Pending",
    ac_status: "",
    approved_amount: "",
  },
];
const pendingApproval = [
  {
    vid: 46154,
    submit_on: new Date(),
    amount: 10600,
    l1_status: "Approved",
    l2_status: "Pending",
    ac_status: "",
    approved_amount: "",
  },
  {
    vid: 46018,
    submit_on: new Date(),
    amount: 3000,
    l1_status: "Approved",
    l2_status: "Pending",
    ac_status: "",
    approved_amount: "",
  },
  {
    vid: 46144,
    submit_on: new Date(),
    amount: 10600,
    l1_status: "Approved",
    l2_status: "Approved",
    ac_status: "",
    approved_amount: "",
  },
  {
    vid: 46233,
    submit_on: new Date(),
    amount: 10600,
    l1_status: "Approved",
    l2_status: "Pending",
    ac_status: "Approved",
    approved_amount: "",
  },
];

const request = [
  {
    date: new Date(),
    head: "Consumables Expenses",
    // sub_head: "Milk",
    description: "Buy 3 litres milk",
    quantity: 3,
    rate: 60,
    amount: 180,
  },
];

const savedVouchers = [
  {
    date: new Date(),
    voucher_head: {
      title: "Operational Expenses",
      sub_title: "Repair & Maintenance",
    },
    amount: 180,
    voucher_comment: "Repair of grinder mixer",
  },
  {
    date: new Date(),
    voucher_head: {
      title: "Employee Welfare",
      sub_title: "Staff Tea, Dinner, Lunch…",
    },
    amount: 180,
    voucher_comment: "Birthday celebration on manager",
  },
];

const assignedToMe = [
  {
    module: "Store View",
    edit: false,
    view: true,
    download: true,
  },
];

const cashDeposits = [
  {
    id: 1,
    date: new Date(),
    description: "Lorem Ipsum is simply dummy text",
    total_sales: 10000,
    cash_deposit: 10000,
  },
  {
    id: 2,
    date: new Date(),
    description: "Lorem Ipsum is simply dummy text",
    total_sales: 10000,
    cash_deposit: 10000,
  },
  {
    id: 3,
    date: new Date(),
    description: "Lorem Ipsum is simply dummy text",
    total_sales: 10000,
    cash_deposit: 10000,
  },
  {
    id: 4,
    date: new Date(),
    description: "Lorem Ipsum is simply dummy text",
    total_sales: 10000,
    cash_deposit: 10000,
  },
  {
    id: 5,
    date: new Date(),
    description: "Lorem Ipsum is simply dummy text",
    total_sales: 10000,
    cash_deposit: 10000,
  },
];

const pettyCashRequest = [
  {
    submit_on: new Date(),
    description:"",
      // "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.",
    r_amount: 10000,
  },
];

const areaManagerVoucherData = [
  {
    head: "Consumables Expenses",
    // sub_head: "Milk, Ice Cream",
    amount: "2000",
    comment: "Repair of grinder mixer",
    subRows: [
      {
        head: "Ice Creams",
        // sub_head: "3 Invoices",
        amount: "600",
        comment: "",
        subRows: [
          {
            date: new Date(),
            head: "Ice Creams",
            amount: "200",
            comment: "Chocolate Ice Cream",
          },
          {
            date: new Date(),
            head: "Ice Creams",
            amount: "200",
            comment: "Chocolate Ice Cream",
          },
          {
            date: new Date(),
            head: "Ice Creams",
            amount: "200",
            comment: "Chocolate Ice Cream",
          },
        ],
      },
    ],
  },
];

export {
  pendingApproval,
  request,
  assignedToMe,
  cashDeposits,
  pettyCash,
  savedVouchers,
  pettyCashRequest,
  areaManagerVoucherData,
};
